import * as React from 'react';
import styled from 'styled-components';
import { FormInputProps } from '../../Deprecated/JRCFormFieldRender';

export const RadioWrapper = styled.div`
    display: block;
    position: relative;
    padding-left: 24px;
    margin-bottom: 16px;
    cursor: pointer;
    user-select: none;

    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .radio-like {
        position: absolute;
        top: 0;
        left: 0;
        height: 16px;
        width: 16px;
        border-radius: 8px;
        background-color: white;
        border: 1px solid ${(props) => props.theme.color.grey3};
    }

    &:hover .radio-like {
        background-color: ${(props) => props.theme.color.grey0};
    }

    & input:checked ~ .radio-like {
        border: 1px solid ${(props) => props.theme.color.primaryD20};
        background-color: ${(props) => props.theme.color.primary};
    }

    .radio-like:after {
        content: '';
        position: absolute;
        display: none;
        width: 8px;
        height: 8px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 4px;
        background-color: white;
    }

    input:checked ~ span:after {
        display: block;
    }
`;
const Radio = function (props: FormInputProps, ref: React.ForwardedRef<HTMLInputElement>) {
    return (
        <RadioWrapper>
            <input {...props} type="radio" ref={ref}></input>
            {/* empty span for toggle styling */}
            <span className="radio-like"></span>
        </RadioWrapper>
    );
};
export const JRCRadio = React.forwardRef(Radio);
